import { useMutation } from "@apollo/client/react";import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import CardBox from "../../CardBox/CardBox";
import { RenderInputByTypeMobile } from "../../../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { useVisita } from "../../../../../../context/VisitaContext";
import SAVE_VISITA_CUMPLIMIENTO_INDICACION_AP, { adaptAddVisitaCumplimientoIndicacionInput } from "../../../../../../data/graphQL/mutations/Visitas/saveVisitaCumplimientoIndicacionAP";
import { useStepSave } from "../../../../hooks/useStepSave";

import { validateStepFields } from "../../../../utils/visitaStepValidation";

export default function CumplimientoDeIndicacion({ esUrgencia, readOnly, onSaveRef, onExposeFormatted }) {
  const [formData, setFormData] = useState({});

  const { visita, setVisita } = useVisita();

  const [save] = useMutation(SAVE_VISITA_CUMPLIMIENTO_INDICACION_AP);

  const formattedInputs = useMemo(() => {
    return inputs.map((input) => {
      const newInput = { ...input };

      if (esUrgencia) newInput.required = false;

      if (readOnly) newInput.disabled = true;

      return newInput;
    });
  }, [readOnly, esUrgencia]);

  const handleChange = useCallback((name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  }, []);

  useStepSave(onSaveRef, async (validate) => {
    if (validate) validateStepFields({ formattedInputs, formData });

    const { data } = await save({ variables: { ...adaptAddVisitaCumplimientoIndicacionInput(formData) } });

    const idCumplimientoIndicacionNueva = data?.saveVisitaCumplimientoIndicacionAP?.idCumplimientoIndicacion;
    if (!idCumplimientoIndicacionNueva) throw new Error("Error al guardar");

    setVisita((prev) => ({
      ...prev,
      ...formData,
      idCumplimientoIndicacion: idCumplimientoIndicacionNueva
    }));

  });


  useEffect(() => {
    setFormData(visita);
  }, [visita]);

  useEffect(() => {
    onExposeFormatted?.({
      stepId: 'cumplimientoDeIndicacion',
      stepName: 'Cumplimiento de indicación',
      formattedInputs
    });
  }, [onExposeFormatted, formattedInputs]);

  return (
    <CardBox>
      <Grid container spacing={2}>
        {formattedInputs.map((input) =>
        <Grid size={{ xs: 12 }} key={input.name}>
            <RenderInputByTypeMobile
            input={input}
            value={formData[input.name]}
            handleChange={handleChange} />
          
          </Grid>
        )}
      </Grid>
    </CardBox>);

}

const inputs = [
{
  name: "cambioIndicacion",
  displayName: "¿Tuvo algún cambio de indicación en la última semana?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "dificultadCumplimiento",
  displayName: "¿Se presentó alguna dificultad en el cumplimiento de lo indicado?",
  longLabel: true,
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "realizaEscalonamiento",
  displayName: "¿Realiza el escalonamiento?",
  type: "boolean",
  lightTitle: true,
  required: true
},
{
  name: "indicacionRealizando",
  displayName: "¿Qué indicación está realizando?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "volumenPorDia",
  displayName: "¿Qué volumen usa por día?",
  type: "int",
  required: true
},
{
  name: "bolsaUtilizando",
  displayName: "¿Qué bolsa está utilizando?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "velocidadBolsa",
  displayName: "¿A qué velocidad pasa la bolsa?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "horaConexion",
  displayName: "¿A qué hora conecta y desconecta?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "quienLoHace",
  displayName: "¿Quién lo hace?",
  type: "long_string",
  maxLength: 250,
  required: true
},
{
  name: "procesoConexion",
  displayName: "Mencione el proceso de conexión y desconexión",
  type: "long_string",
  maxLength: 250,
  required: true
}];